module.exports = __webpack_public_path__ + "static/media/Heidi Zimmerman Headshot.ea09e55f.jpeg";